<p>
  detail-person works!
</p>
